const localUserDateFieldsByEntity = {
  activitypointer: new Set(["createdon", "modifiedon"]),
  g4b_booking: new Set(["createdon", "modifiedon"]),
  g4b_bookingpayment: new Set([
    "createdon",
    "modifiedon",
    "g4b_paymentdate",
  ]),
  g4b_bookingproduct: new Set(["createdon", "modifiedon"]),
  g4b_channel: new Set(["createdon", "modifiedon"]),
  g4b_channelpricelist: new Set(["createdon", "modifiedon"]),
  g4b_coupon: new Set([
    "createdon",
    "modifiedon",
    "g4b_purchasedate",
    "g4b_notvaliduntildate",
    "g4b_redeembydate",
    "g4b_usebydate",
    "g4b_expirydate",
    "g4b_expirydatewithgraceperiod",
  ]),
  g4b_journalentry: new Set(["createdon", "modifiedon"]),
  g4b_journalpayment: new Set(["createdon", "modifiedon"]),
  g4b_productbase: new Set([
    "createdon",
    "modifiedon",
    "g4b_availabledatefrom",
    "g4b_availabledateto",
  ]),
  g4b_protoproduct: new Set(["createdon", "modifiedon"]),
  g4b_ticket: new Set(["createdon", "modifiedon"]),
  g4b_varianttype: new Set(["createdon", "modifiedon"]),
  g4c_communicationactivity: new Set([
    "createdon",
    "modifiedon",
    "scheduledstart",
  ]),
  g4c_communication: new Set(["g4c_startdate", "g4c_enddate"]),
  g4c_communicationaudit: new Set([
    "createdon",
    "modifiedon",
    "g4c_auditdate",
  ]),
  g4c_abtest: new Set([
    "g4c_startdate",
    "g4c_enddate",
    "g4c_testperiodenddate",
  ]),
  g4gdpr_contactaudit: new Set([
    "createdon",
    "modifiedon",
    "g4gdpr_modifiedon",
  ]),
};

const maintainEnteredDateTimeFieldsByEntity = {
  g4b_channelpricelist: new Set([
    "g4b_onsaledate",
    "g4b_offsaledate",
    "g4b_activitystartdate",
    "g4b_activityenddate",
  ]),
  g4b_calendaritem: new Set([
    "g4b_startdate",
    "g4b_enddate",
    "g4b_opentime",
    "g4b_closetime",
    "g4b_peaktime",
    "g4b_peakend",
  ]),
};

const hasDateFieldRule = (
  entityFieldMap,
  entityName,
  fieldName
) => {
  if (!entityName || !fieldName) {
    return false;
  }

  return entityFieldMap[entityName]?.has(fieldName) ?? false;
};

const isLocalUserDateField = (entityName, fieldName) =>
  hasDateFieldRule(
    localUserDateFieldsByEntity,
    entityName,
    fieldName
  );

const utcToLocalEditFormFieldsByEntity = {
  g4b_productbase: new Set([
    "g4b_availabledatefrom",
    "g4b_availabledateto",
  ]),
  g4c_communication: new Set(["g4c_startdate", "g4c_enddate"]),
  g4c_abtest: new Set([
    "g4c_startdate",
    "g4c_enddate",
    "g4c_testperiodenddate",
  ]),
};

const shouldConvertUtcToLocalForEditForm = (
  entityName,
  fieldName
) =>
  hasDateFieldRule(
    utcToLocalEditFormFieldsByEntity,
    entityName,
    fieldName
  );

const shouldMaintainEnteredDateTime = (entityName, fieldName) =>
  hasDateFieldRule(
    maintainEnteredDateTimeFieldsByEntity,
    entityName,
    fieldName
  );

export {
  isLocalUserDateField,
  localUserDateFieldsByEntity,
  maintainEnteredDateTimeFieldsByEntity,
  shouldConvertUtcToLocalForEditForm,
  shouldMaintainEnteredDateTime,
};

export default localUserDateFieldsByEntity;
